package com.essntl.features.contact.domain.model

data class GetContactModel(
    val id: String,
    val name: String,
)